import { ReadonlyRefObject, useLayoutEffect } from "react";
import { AlertManager, useAlerts } from "./useAlerts";
import Clipboard from "clipboard";
import { localize } from "client_legacy/ndaw/culture";

export function useCopyToClipboard<T extends HTMLElement>(
	ref: ReadonlyRefObject<T | null>,
	value: string
): void {
	const alertManager: AlertManager = useAlerts();

	useLayoutEffect(
		(): (() => void) | undefined => {
			if (!ref.current) {
				return;
			}

			const clipboard = new Clipboard(
				ref.current,
				{
					text: () => value
				}
			);

			clipboard.on(
				"success",
				() => {
					alertManager.showSuccess(
						localize("_CopyToClipboardSuccesfull")
					);
				}
			);

			return (): void => {
				clipboard.destroy();
			};
		},
		[
			alertManager,
			ref,
			value
		]
	);
}